
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomActionBar from './CustomActionBar';
import MobileWheelTimePicker from './MobileWheelTimePicker';
import WheelTimePicker from './WheelTimePicker';

const DateRangeOnlyView = ({ startDate, setStartDate, setStartValue, endDate, setEndDate, setEndValue, shouldUpdate, setUpdated }) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [date, setDate] = useState([
        moment(),
        moment()
    ]);
    const emtpyHoursAndMinutes = moment().set("hours", 0).set("minutes", 0).add(1, "days");
    const [close, setClose] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (moment(endDate).diff(moment(startDate), "hours") < 24 && shouldUpdate) {
            const startDateAsMoment = moment(startDate);
            const endDateForDateRange = moment(startDate);
            endDateForDateRange.add(1, "day");
            endDateForDateRange.add(moment(endDate).diff(moment(startDate)));
            setDate([
                startDateAsMoment,
                endDateForDateRange
            ]);
            setEndDate(endDateForDateRange);
            setEndValue(endDateForDateRange);
        }
        setDate([
            startDate,
            endDate
        ])
        //eslint-disable-next-line
    }, [startDate, endDate])

    const Seperator = () => {

        return (
            <Box
                sx={{ display: 'inline-block', transform: 'scale(1.2)', pl: 1.5, pt: 1 }}
            >
                _
            </Box>
        )
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={localStorage.getItem("i18nextLng")}>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pb: belowsm ? 0 : 2,
                    ml: 1
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <DateRangePicker
                            localeText={{
                                start: t("startdate"),
                                end: t("enddate")
                            }}
                            format="DD.MM.YYYY"
                            value={date}
                            onChange={(newDate) => {
                                setDate(newDate);
                            }}
                            onOpen={() => { setClose(true); }}
                            onClose={() => { setClose(false); }}
                            onAccept={(date) => {
                                const date0 = moment(date[0])
                                date0.set("hour", moment(startDate).hours());
                                date0.set("minute", moment(startDate).minutes())
                                const date1 = moment(date[1])
                                date1.set("hour", moment(startDate).hours());
                                date1.set("minute", moment(startDate).minutes())
                                const withTime = [
                                    date0,
                                    date1
                                ];
                                setStartDate(withTime[0]);
                                setStartValue(withTime[0]);
                                if (date[1]) {
                                    setEndDate(withTime[1]);
                                    setEndValue(withTime[1]);
                                } else {
                                    const newEndDate = moment(withTime[0]);
                                    newEndDate.set("hour", moment(startDate).hours()).add(1, "day");
                                    setDate([withTime[0], newEndDate]);
                                    setEndDate(newEndDate);
                                    setEndValue(newEndDate);
                                }
                                if (setUpdated) {
                                    setUpdated(true);
                                }
                            }}
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                desktopPaper: {
                                    sx: {
                                        backgroundImage: "none"
                                    }
                                },
                                mobilePaper: {
                                    sx: {
                                        pt: 2,
                                        borderRadius: 6,
                                        backgroundImage: "none"
                                    }
                                },
                                textField: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                toolbar: {
                                    hidden: true
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pt: 0,
                    ml: 1,
                }}
            >
                <Grid container sx={{ display: belowsm ? "none" : "flex" }}>
                    <Grid item xs={5.5} sx={{ pr: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("start-time")} time={emtpyHoursAndMinutes} setTime={() => { console.log("this shouldn't happen.") }} disable={true} /> :
                                <WheelTimePicker label={t("start-time")} value={emtpyHoursAndMinutes} setValue={() => { console.log("this shouldn't happen.") }} close={close} disable={true} />
                        }
                    </Grid>
                    <Grid item xs={1} sx={{ visibility: "hidden" }}>
                        <Seperator />
                    </Grid>
                    <Grid item xs={5.5} sx={{ pl: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("end-time")} time={emtpyHoursAndMinutes} setTime={() => { console.log("this shouldn't happen.") }} disable={true} /> :
                                <WheelTimePicker label={t("end-time")} value={emtpyHoursAndMinutes} setValue={() => { console.log("this shouldn't happen.") }} close={close} disable={true} />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );

};

export default DateRangeOnlyView;